import { useTranslation } from '@multaqa/i18n'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { TwoFactorChallengeForm } from '@/features/auth/two-factor-challenge'
import { currentUserQuery } from '@/lib/auth'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 *
 * `redirect` arrives from the login form, which forwards the guard's target
 * through the second step so a completed challenge lands the visitor back
 * where they were headed before signing in.
 */
export const Route = createFileRoute('/two-factor')({
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(currentUserQuery)
      throw redirect({ to: '/' })
    } catch (error) {
      if (error instanceof Response && error.status === 307) {
        throw error
      }

      if ((error as { status?: number }).status !== 401) {
        throw error
      }
    }
  },
  component: TwoFactorRoute,
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
})

function TwoFactorRoute() {
  const { t } = useTranslation()

  return (
    <>
      <p className="text-small text-muted-foreground text-center">
        {t('auth.twoFactor.noChallenge')}{' '}
        <a href="/login" className="underline-offset-2 hover:underline">
          {t('auth.backToSignIn')}
        </a>
      </p>
      <TwoFactorChallengeForm />
    </>
  )
}
